module.exports = __webpack_public_path__ + "img/photo-0031.e7f4046a.jpg";